<template>
  <v-client-table :data='getIndicesValeurs'
    class="column is-12 displayNoneVuePagination"
    :columns="columns" :options="options"
    ref="tableIndicesValeurs">
    <template slot="dateReference" slot-scope="props">
      <div class="has-text-right">
        {{ func.formatDate(props.row.dateReference) }}
      </div>
    </template>
    <template slot="trimestre" slot-scope="props">
      <div>
        {{ props.row.trimestre }}
      </div>
    </template>
    <template slot="valeurIndice" slot-scope="props">
      <div class="has-text-right">
        {{ props.row.valeurIndice }}
      </div>
    </template>
  </v-client-table>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import moment from 'moment';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'tableValeurIndice',
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      func: {
        formatDate,
      },
    };
  },
  computed: {
    getIndicesValeurs() {
      const indicesValeurs = cloneDeep(this.data.indiceValeurs);
      return indicesValeurs.sort((a, b) => moment(b.dateReference) - moment(a.dateReference));
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateReference: this.$t('listeIndiceEtValeur.childrow.dateReference'),
          trimestre: this.$t('listeIndiceEtValeur.childrow.trimestre'),
          valeurIndice: this.$t('listeIndiceEtValeur.childrow.valeurIndice'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          dateReference: 'width-250 ',
        },
        sortable: ['dateReference', 'trimestre', 'valeurIndice'],
      };
    },
    columns() {
      return ['dateReference', 'trimestre', 'valeurIndice'];
    },
  },
};

</script>
